import ApiClient from "src/utils/ApiClient";

export const OrganizationStructureApiClient = new ApiClient({
  baseURL: `/api/organization-structure/omb`,
  headers: {},
}).client;

export const EmployeeApiClient = new ApiClient({
  baseURL: `/api/employee-management`,
  headers: {},
}).client;
